import FeedLayout from "layouts/files/FeedLayout";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "services/redux/store";
import { SVG, SettingsItem, SettingsToggler } from "ui";

const Account = () => {
    const { avatar, name } = useSelector((state: RootState) => state.account);
    return (
        <FeedLayout pageTitle="Settings">
            <div className="settings-page">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/settings">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Your Account</h1>
                    <div></div>
                </div>
                <div className="card pl-10 pr-10 pt-10 pb-10">
                    <div className="member-sm-card community-list-request-img p-relative text-center pt-30">
                        <img
                            src={avatar}
                            alt=""
                            style={{ width: 100, height: 100, marginRight: 0 }}
                        />
                        <h1 className="white-text fw-700 fs-20em">{name}</h1>
                    </div>
                    {/* account info */}
                    <SettingsItem
                        svg="user"
                        title="Account info"
                        details="See information about your account, update your details also deception option."
                        link="/settings/account/info"
                    />
                    {/* change pswd */}
                    <SettingsItem
                        svg="lock"
                        title="Change Password"
                        details="Set New Password"
                        link="/settings/account/password"
                    />
                    {/* visibility */}
                    <SettingsToggler
                        svg="show-pswd"
                        title="Status Visibility"
                        defaultCheck
                    />
                    <SettingsToggler
                        svg="user-double-check"
                        title="Followers Visibility"
                        defaultCheck
                    />
                    <SettingsToggler
                        svg="curved-arrow"
                        title="Indirect Followers Visibility"
                        defaultCheck
                    />
                    <SettingsToggler
                        svg="show-pswd"
                        title="Status Bottom Popup"
                        defaultCheck
                    />
                    {/* topics */}
                    <SettingsItem
                        svg="slash"
                        title="Delete Your Account"
                        details="Find out how you can delete your account"
                        link="/settings/account/delete"
                    />
                </div>
            </div>
        </FeedLayout>
    );
};

export default Account;
